import React, { useCallback } from 'react'
import { Navigate, useNavigate } from 'react-router-dom'
import { useStateAuthContext, useStateHostContext } from '../context'
import { error, success } from '../notify'
import { Modal, Button, Table } from 'react-bootstrap'

const Opd_pengguna_kendaraan_tambah = () => {
      window.document.title = "Tambah Pengguna"
      const direct = useNavigate();
      const { HOST } = useStateHostContext();
      const { STATE_AUTH } = useStateAuthContext();
      const form_ref = React.useRef();
      const [is_submit, set_submit] = React.useState(false);

      const [nip, set_nip] = React.useState("");
      const [nama, set_nama] = React.useState("");
      const [jabatan, set_jabatan] = React.useState("");
      const [foto, setFoto] = React.useState("");

      // Modal SIAP-ASN
      const [showModal, setShowModal] = React.useState(false);
      const [siapAsnData, setSiapAsnData] = React.useState([]);
      const [filteredData, setFilteredData] = React.useState([]);
      const [loading, setLoading] = React.useState(false);
      const [searchTerm, setSearchTerm] = React.useState('');

      const handleShowModal = () => {
            setShowModal(true);
            setSearchTerm('');
      };
      const handleCloseModal = () => setShowModal(false);

      const fetchSiapAsnData = useCallback(async () => {
            setLoading(true);
            try {
                  const response = await fetch(
                        `https://kotamobagu.go.id/backend/api/siap-asn/index.php?pegawai=all&id_opd=${STATE_AUTH.id_opd_siapasn}`,
                        { method: 'GET', headers: { 'Accept': 'application/json' } }
                  );
                  const result = await response.json();

                  if (result.status === 'success') {
                        setSiapAsnData(result.data);
                        setFilteredData(result.data);
                  } else {
                        error({ msg: 'Gagal mengambil data dari SIAP-ASN' });
                        setSiapAsnData([]);
                        setFilteredData([]);
                  }
            } catch (err) {
                  error({ msg: 'Terjadi kesalahan saat mengambil data: ' + err.message });
                  setSiapAsnData([]);
                  setFilteredData([]);
            } finally {
                  setLoading(false);
            }
      }, [STATE_AUTH.id_opd_siapasn]);

      React.useEffect(() => {
            if (showModal) fetchSiapAsnData();
      }, [showModal, fetchSiapAsnData]);

      // Filter pencarian
      React.useEffect(() => {
            if (siapAsnData.length > 0) {
                  const filtered = siapAsnData.filter(pegawai => {
                        const nip = pegawai.nip_baru?.toLowerCase() || '';
                        const nama = pegawai.nama?.toLowerCase() || '';
                        const jabatan = pegawai.jabatan?.toLowerCase() || '';
                        const term = searchTerm.toLowerCase();

                        return nip.includes(term) || nama.includes(term) || jabatan.includes(term);
                  });
                  setFilteredData(filtered);
            } else {
                  setFilteredData([]);
            }
      }, [searchTerm, siapAsnData]);


      const handleResetForm = () => {
            set_nip("");
            set_nama("");
            set_jabatan("");
            setFoto("");
      };

      const handleSubmit = (e) => {
            e.preventDefault();
            set_submit(true);

            const formData = new FormData();
            formData.append('NIP', nip);
            formData.append('NAMA', nama);
            formData.append('JABATAN', jabatan);
            if (foto) formData.append('FOTO', foto);

            const param = {
                  method: 'POST',
                  headers: {
                        "REST-ID-OPD": STATE_AUTH.id_opd,
                        "REST-TOKEN": STATE_AUTH.token
                  },
                  body: formData
            };

            const sendData = async () => {
                  try {
                        const requ = await fetch(HOST + '/user/kendaraan/pengguna/simpan', param);
                        const resp = await requ.json();

                        if (resp.s) {
                              success({ msg: resp.m });
                              handleResetForm();
                              form_ref.current.reset();
                              set_submit(false);

                              setTimeout(() => {
                                    if (!window.confirm('Tambah pengguna lagi?')) {
                                          direct('/opd/pengguna/kendaraan');
                                    }
                              }, 3000);
                        } else {
                              error({ msg: resp.m });
                              set_submit(false);
                        }
                  } catch (err) {
                        error({ msg: 'Masalah ditemukan: ' + err.message });
                        set_submit(false);
                  }
            };

            sendData();
      };

      if (!STATE_AUTH.is_login) {
            return <Navigate to="/" />;
      }

      return (
            <>
                  {/* MODAL */}
                  <Modal show={showModal} onHide={handleCloseModal} size="lg" backdrop="static">
                        <Modal.Header closeButton>
                              <Modal.Title>Import dari SIAP-ASN</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                              {loading ? (
                                    <div className="text-center p-4">
                                          <div className="spinner-border" role="status">
                                                <span className="visually-hidden">Loading...</span>
                                          </div>
                                          <p className="mt-2">Mengambil data dari SIAP-ASN...</p>
                                    </div>
                              ) : (
                                    <div>
                                          <div className="mb-3">
                                                <input
                                                      type="text"
                                                      className="form-control"
                                                      placeholder="Cari berdasarkan NIP, Nama, atau Jabatan..."
                                                      value={searchTerm}
                                                      onChange={(e) => setSearchTerm(e.target.value)}
                                                />
                                          </div>
                                          <p className="mb-3">Pilih pegawai dari SIAP-ASN untuk ditambahkan:</p>
                                          {filteredData.length > 0 ? (
                                                <Table striped bordered hover responsive className="table-sm">
                                                      <thead>
                                                            <tr>
                                                                  <th>No</th>
                                                                  <th>Foto</th>
                                                                  <th>NIP</th>
                                                                  <th>Nama</th>
                                                                  <th>Jabatan</th>
                                                                  <th>Aksi</th>
                                                            </tr>
                                                      </thead>
                                                      <tbody>
                                                            {filteredData.map((pegawai, index) => (
                                                                  <tr key={index}>
                                                                        <td>{index + 1}</td>
                                                                        <td>
                                                                              {pegawai.gambar ? (
                                                                                    <img
                                                                                          src={'https://siap-asn.kotamobagu.go.id' + pegawai.gambar}
                                                                                          alt={pegawai.nama}
                                                                                          style={{
                                                                                                width: '80px',
                                                                                                height: '80px',
                                                                                                objectFit: 'cover',
                                                                                                borderRadius: '4px'
                                                                                          }}
                                                                                    />
                                                                              ) : (
                                                                                    <div
                                                                                          style={{
                                                                                                width: '80px',
                                                                                                height: '80px',
                                                                                                backgroundColor: '#ddd',
                                                                                                display: 'flex',
                                                                                                alignItems: 'center',
                                                                                                justifyContent: 'center',
                                                                                                borderRadius: '4px'
                                                                                          }}
                                                                                    >
                                                                                          <i className="fa fa-user" style={{ color: '#666' }}></i>
                                                                                    </div>
                                                                              )}
                                                                        </td>
                                                                        <td>{pegawai.nip_baru}</td>
                                                                        <td>{pegawai.nama}</td>
                                                                        <td>{pegawai.jabatan}</td>
                                                                        <td>
                                                                              <Button
                                                                                    variant="success"
                                                                                    size="sm"
                                                                                    onClick={() => {
                                                                                          set_nip(pegawai.nip_baru);
                                                                                          set_nama(pegawai.nama);
                                                                                          set_jabatan(pegawai.jabatan);
                                                                                          setFoto(pegawai.gambar ? `https://siap-asn.kotamobagu.go.id` + pegawai.gambar : "");
                                                                                          handleCloseModal();
                                                                                    }}
                                                                              >
                                                                                    Pilih
                                                                              </Button>
                                                                        </td>
                                                                  </tr>
                                                            ))}
                                                      </tbody>
                                                </Table>
                                          ) : (
                                                <div className="text-center p-4">
                                                      <p>Tidak ada data pegawai ditemukan dari SIAP-ASN.</p>
                                                </div>
                                          )}
                                    </div>
                              )}
                        </Modal.Body>
                        <Modal.Footer>
                              <Button variant="secondary" onClick={handleCloseModal}>
                                    Tutup
                              </Button>
                        </Modal.Footer>
                  </Modal>

                  {/* MAIN CONTENT */}
                  <main>
                        <div className="container-fluid">
                              <div className="row mt-3">
                                    <div className="col-md-12">
                                          <h3><strong><i className='fa fa-user-alt'></i> TAMBAH PENGGUNA KENDARAAN BARU</strong></h3>
                                    </div>
                              </div>
                              <hr />
                              <button className='btn btn-sm btn-warning' onClick={() => direct('/opd/pengguna/kendaraan')}>
                                    <i className='far fa-arrow-alt-circle-left'></i> Kembali
                              </button>
                              <button className='btn btn-sm btn-info' onClick={handleShowModal} style={{ marginLeft: '10px' }}>
                                    Import dari SIAP-ASN
                              </button>
                              <hr />

                              <form onSubmit={handleSubmit} ref={form_ref}>
                                    <div className="row">
                                          <div className="col-md-8">
                                                <div className="input-group input-group-sm mb-1">
                                                      <span className="input-group-text" style={{ width: '25%' }}>NIP</span>
                                                      <input
                                                            name="nip"
                                                            type="text"
                                                            className="form-control"
                                                            onChange={e => set_nip(e.target.value)}
                                                            value={nip}
                                                      />
                                                </div>
                                                <div className="input-group input-group-sm mb-1">
                                                      <span className="input-group-text" style={{ width: '25%' }}>Nama</span>
                                                      <input
                                                            name="nama"
                                                            type="text"
                                                            className="form-control"
                                                            onChange={e => set_nama(e.target.value)}
                                                            value={nama}
                                                      />
                                                </div>
                                                <div className="input-group input-group-sm mb-1">
                                                      <span className="input-group-text" style={{ width: '25%' }}>Jabatan</span>
                                                      <input
                                                            name="jabatan"
                                                            type="text"
                                                            className="form-control"
                                                            onChange={e => set_jabatan(e.target.value)}
                                                            value={jabatan}
                                                      />
                                                </div>

                                                <button type='submit' className='btn btn-primary mt-2' disabled={is_submit}>
                                                      <i className='fa fa-save'></i> {is_submit ? 'Mohon tunggu...' : 'Simpan'}
                                                </button>
                                          </div>
                                          <div className="col-md-4 text-center">
                                                {foto && (
                                                      <div className="mb-3">
                                                            <img
                                                                  src={foto}
                                                                  alt="Foto Pegawai"
                                                                  style={{
                                                                        width: '200px',
                                                                        height: '200px',
                                                                        objectFit: 'cover',
                                                                        borderRadius: '8px',
                                                                        border: '1px solid #ddd'
                                                                  }}
                                                            />
                                                      </div>
                                                )}
                                                {!foto && (
                                                      <div className="mb-3">
                                                            <div
                                                                  style={{
                                                                        width: '200px',
                                                                        height: '200px',
                                                                        backgroundColor: '#ddd',
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        justifyContent: 'center',
                                                                        borderRadius: '4px'
                                                                  }}
                                                            >
                                                                  Tidak ada foto
                                                            </div>
                                                      </div>
                                                )}
                                          </div>
                                    </div>
                              </form>
                        </div>
                  </main>
            </>
      );
};

export default Opd_pengguna_kendaraan_tambah;
